import { STATICS } from "api/api";
import { Icon } from "assets/Icons_"
import { useBreak } from "hooks/useBreak";
import { useTranslation } from "react-i18next";
import { Footer, Inner } from "./NoAvailableUnit.Portal.style";
import { CustomButton } from "components/Unit/NewReservationButton";

export const ThankYouPage = ({ click, size, wrap, color, icon, setAvailableUnit, setStep }) => {
    const { i18n:{language} }             = useTranslation()
    const isMobile                        = useBreak("md_dn");
    const close   = { icon, color, wrap, size, click }
    
    return <>
            <img       src      = {`${STATICS}/svg/no-available-unit-thank-you-image.svg`} alt = '' style = {{ height : isMobile ? "150px" : "250px", objectFit: "contain", borderRadius:"6px", marginTop: "24px" }} />
            <Icon {...close} />
            <Inner>
                <div    className = 'h3'>{ form1Translation['heading'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph1'][language] }</div>
                <div    className = 'paragraph1-regular'>{ form1Translation['paragraph2'][language] }</div>
            </Inner>
            <Footer style={{ padding: "0 16px 16px 16px"}}>
                    <CustomButton
                    padding = {'12px 24px'}
                    variant = { "secondary" }
                    onClick = {() => setAvailableUnit(false)}
                    clr = {clr}
                  >
                    <span className = "eus-button-2">
                      { form1Translation['button1'][language] }
                    </span>
                    </CustomButton>
             </Footer>
    </>
}


const form1Translation = {
    'heading': {
      'en': 'Thank you for your sign up!',
      'da': 'Tak for din tilmelding!'
    },
    'paragraph1': {
      'en': 'We have successfully created your matching profile!',
      'da': 'Vi har oprettet din matchende profil!'
    },
    'paragraph2': {
      'en': 'When a unit that matches your needs become available you will get notified on email.',
      'da': 'Når en enhed, der matcher dine behov bliver tilgængelig, får du besked på e-mail.'
    },
    'button1': {
      'en': 'Close',
      'da': 'Tæt'
    }
  }